import React from 'react';
import { toast } from 'sonner';
import { CheckCheck, Bell } from 'lucide-react';
import { Panel, Empty, Badge } from '../../components/Primitives';
import { useFetch } from '../../lib/hooks';
import { api, fmtDate } from '../../lib/api';

const TONE = { success: 'green', warning: 'gold', security: 'gold', info: 'blue', error: 'red' };

export default function Notifications() {
  const { data: list, reload } = useFetch('/notifications', [], 20000);
  const markAll = async () => { await api.post('/notifications/read-all'); toast.success('All marked read'); reload(); };
  const markOne = async (id) => { await api.post(`/notifications/${id}/read`); reload(); };

  return (
    <div data-testid="notifications-page">
      <Panel title="Notifications" action={<button onClick={markAll} className="h-9 px-3 rounded-lg border border-border text-xs inline-flex items-center gap-1.5 hover:border-vj-neon/50" data-testid="notif-read-all"><CheckCheck size={13} /> Mark all read</button>}>
        {list && list.length ? (
          <div className="space-y-2">
            {list.map((n) => (
              <button key={n.id} onClick={() => markOne(n.id)} className={`w-full text-left flex items-start gap-3 p-3 rounded-lg border transition-colors ${n.read ? 'border-border opacity-70' : 'border-vj-neon/30 bg-vj-neon/5'}`} data-testid={`notif-${n.id}`}>
                <div className="w-8 h-8 rounded-lg bg-white/5 grid place-items-center shrink-0"><Bell size={14} className="text-vj-neon" /></div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2"><span className="text-sm font-medium">{n.title}</span><Badge tone={TONE[n.kind] || 'grey'}>{n.kind}</Badge></div>
                  <div className="text-xs text-vj-grey mt-0.5">{n.body}</div>
                  <div className="text-[11px] text-vj-grey mt-1">{fmtDate(n.created_at)}</div>
                </div>
              </button>
            ))}
          </div>
        ) : <Empty>No notifications yet.</Empty>}
      </Panel>
    </div>
  );
}
